import React from "react";

export const LogicButton = (props) => {
    const {label, icon, onClick, disabled, className} = props;
    return (
        <button
            className={className}
            onClick={onClick}
            disabled={disabled}
        >
            <span className="button-label">{label}</span>
            {icon}
        </button>
    )
}